import { createApp } from 'vue'
import App from './App.vue'
import { BootstrapVue3 } from 'bootstrap-vue-3'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import 'v-calendar/dist/style.css'
import i18n from './i18n.js'
import router from './router'
import store from './store'
import VCalendar from 'v-calendar'
import VueAxios from 'vue-axios'
import axios from 'axios'
import apiCallHandler from './apiCallHandler'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import css from './index.css'
import Const from './const'

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(BootstrapVue3)
  .use(VCalendar)
  .use(VueAxios, axios)
  .use(apiCallHandler)
  .use(VueReCaptcha, {
    siteKey: Const.RECAPTCHA_SITE_KEY,
    loaderOptions:{
      autoHideBadge: true,
      renderParameters: {
        'badge': 'inline'
      }     
    }
  })
  .use(css)
  .mount('#app')
